import React from 'react';
import * as R from 'ramda';

import {mapWithIndex, maybe} from '@/util';

const errorItem = (msg, idx) => <li key={idx}>{msg}</li>;
const errorList = val => (
  <ul
    style={{
      listStyleType: 'none',
      marginBottom: '0px',
      paddingInlineStart: '0px',
    }}
  >
    {val}
  </ul>
);

const errorBlock = val => <div className='alert alert-danger'>{val}</div>;

const BaseError = ({errors}) => {
  const baseError = R.propOr(false, 'base', errors);

  return maybe(baseError)
    .map(mapWithIndex(errorItem))
    .map(errorList)
    .map(errorBlock)
    .orNull();
};

export default BaseError;
